import fetch from "auth/FetchInterceptor";

const authUserService = {};

authUserService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/auth-role",
		method: "get",
		params,
	});
};

authUserService.post = function (data) {
	return fetch({
		url: "/v1/rest/auth-role",
		method: "post",
		data: data,
	});
};

authUserService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/auth-role/${id}`,
		method: "put",
		data: data,
	});
};

authUserService.getById = function (id) {
	return fetch({
		url: `/v1/rest/auth-role/${id}`,
		method: "get",
	});
};

export default authUserService;
